export default "__VITE_ASSET__BCdqHD22__"